<HomeNavBar />

<div class="mt-4 mb-5 pb-5" v-if="order" >
  <div class="row justify-content-center">
    <div class="col-md-7">
      <div class="step-content bg-white shadow-lg p-4 p-md-5 rounded-5 border border-light">

        <!-- Header -->
        <h2 class="text-center text-primary fw-bold mb-4">Event Payment</h2>

        <!-- Order Summary Card -->
        <div class="bg-light p-4 rounded-5 border shadow-sm mb-4">
          <h4 class="fw-semibold position-relative pb-2 mb-4 text-secondary">
            Order Summary
            <span class="position-absolute bottom-0 start-0 bg-primary divider-line"></span>
          </h4>

          <!-- Order Info Table -->
          <table class="table table-borderless text-dark mb-3">
            <tbody>
                <tr>
                  <td class="text-muted fw-semibold w-25">Order #:</td>
                  <td class="fw-semibold">{{ order.id }}</td>
                </tr>
                <tr>
                  <td class="text-muted fw-semibold">Event:</td>
                  <td class="fw-semibold">{{ order.event_name }}</td>
                </tr>
                <tr>
                  <td class="text-muted fw-semibold">Location:</td>
                  <td class="fw-semibold">{{ order.location }}</td>
                </tr>
                <tr>
                  <td class="text-muted fw-semibold">Order Date:</td>
                  <td class="fw-semibold">{{ formatDateTime(order.order_date) }}</td>
                </tr>
                <tr>
                  <td class="text-muted fw-semibold">Event Dates:</td>
                  <td class="fw-semibold">
                    {{ order.start_date }}, {{order.start_time}} to {{ order.end_date }}, {{order.end_time}}
                  </td>
                </tr>
              </tbody>

          </table>

          <!-- Tickets List -->
          <ul class="list-group mb-3">
            <li
              v-for="item in order.items"
              :key="item.id"
              class="list-group-item d-flex justify-content-between align-items-center border-0 rounded-3 mb-2 bg-gray"
            >
              <div>
                <small class="text-muted me-1">{{ item.quantity_ordered }} x</small>

                <span class="fw-semibold text-dark">{{ item.ticket_name }}</span>
              </div>
              <span class="fw-semibold text-dark">R{{ item.total_amount}}</span>
            </li>
          </ul>

          <!-- Total -->
          <div v-if="order?.order_promos?.length && order.order_promos.length > 0">
            <!-- Subtotal Row -->
            <div class="d-flex justify-content-between align-items-center py-2">
              <span class="text-muted text-sm">Subtotal</span>
              <span class="fw-semibold text-dark me-3">R{{ order.total_cost }}</span>
            </div>

            <!-- Discount Row -->
            <div class="d-flex justify-content-between align-items-center py-2">
              <span class="text-success fw-semibold text-sm">
                <i class="bi bi-tag-fill"></i>
                Discount
              </span>
              <span class="text-success fw-bold">
                -{{ order.order_promos[0]?.promo_code.promo_code_type?.name === 'percentage' ?
                  order.order_promos[0]?.promo_code.discount_amount + '%' :
                  'R' + order.order_promos[0]?.promo_code.discount_amount }} off
              </span>
            </div>
            <!-- Divider -->
            <hr class="my-2 border-light">
            <!-- Total Row -->
            <div class="d-flex justify-content-between align-items-center py-2">
              <span class="fw-bold text-dark">Total</span>
              <span class="fw-bold text-primary">R{{ order.order_promos[0].total_discount_amount }}</span>
            </div>
          </div>
          <div v-else class="d-flex justify-content-between align-items-center pt-3 mt-2 fw-bold fs-5 text-dark border-top border-light">
            <span>Total</span>
            <span>R{{ order.total_cost}}</span>
          </div>

          <!-- Payment Status -->
          <p class="mt-3 mb-0">
            Payment Status: 
            <span :class="['badge', order.payment_status === 'COMPLETE' ? 'bg-success' : 'bg-warning']">
              {{ order.payment_status }}
            </span>
          </p>
        </div>

        <!-- Navigation Buttons -->
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-2">

          <!-- Back + Proceed (NOT COMPLETE) -->
          <a
            v-if="order.payment_status !== 'COMPLETE'"
            class="btn btn-primary rounded-pill px-4 py-2 fw-semibold shadow-sm  w-100"
            :href="`/view_events`"
          >
            Cancel
          </a>

          <button
            v-if="order.payment_status !== 'COMPLETE'"
            class="btn btn-primary rounded-pill px-4 py-2 fw-semibold shadow-sm  w-100"
            @click="completeEventPayment"
          >
            Proceed to Checkout
          </button>

          <!-- Payment COMPLETE view -->
          <div
            v-if="order.payment_status === 'COMPLETE'"
            class="w-100 text-center"
          >
            <div class="text-success fw-bold mb-2 fs-5">
              Payment Successful
            </div>

            <a
              :href="`/view_events`"
              class="btn btn-primary rounded-pill px-4 py-2 fw-semibold shadow-sm w-100"
            >
              Back to Event
            </a>
          </div>

        </div>

        <!-- Hidden Payment Form -->
        <form id="payment_form" :action="payfast" method="POST" class="d-none">
          <input type="submit" value="Submit" />
        </form>
        <input type="hidden" id="input_clone" class="d-none" />

      </div>
    </div>
  </div>
</div>

<div v-else class="text-center py-5">
  <div class="spinner-border text-success" role="status"></div>
  <p class="mt-3">Loading checkout...</p>
</div>
